import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BADGE = {
  paid: "bg-forest text-ivory", pending: "bg-champagne text-espresso",
  expired: "bg-espresso/20 text-espresso", failed: "bg-red-200 text-red-900", refunded: "bg-espresso/20 text-espresso",
};

export default function AdminPayments() {
  const [items, setItems] = useState([]);

  const load = useCallback(() => api.get("/admin/payments").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="admin-payments">
      <h1 className="font-serif text-4xl text-espresso">Payments</h1>
      <p className="text-espresso/60 mt-2">{items.length} transactions</p>

      <div className="mt-8 bg-taupe rounded-2xl p-6 overflow-x-auto">
        {items.length === 0 ? <p className="text-espresso/50">No transactions yet.</p> : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-espresso/50 border-b border-champagne/30">
                <th className="py-3 pr-4">Package</th><th className="py-3 pr-4">Amount</th>
                <th className="py-3 pr-4">Email</th><th className="py-3 pr-4">Status</th><th className="py-3">Date</th>
              </tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.session_id} className="border-b border-champagne/20" data-testid={`payment-row-${p.session_id}`}>
                  <td className="py-3 pr-4 text-espresso">{p.package_name}</td>
                  <td className="py-3 pr-4 text-espresso">${(p.amount / 100).toFixed(2)} {p.currency?.toUpperCase()}</td>
                  <td className="py-3 pr-4 text-espresso/70">{p.customer_email || "—"}</td>
                  <td className="py-3 pr-4"><span className={`rounded-full px-3 py-1 text-xs ${BADGE[p.payment_status] || "bg-espresso/10 text-espresso"}`}>{p.payment_status}</span></td>
                  <td className="py-3 text-espresso/60">{new Date(p.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
